/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import notice from 'src/common/components/Notice';
import moment from 'moment';
import 'moment/locale/es';
import CustomButton from 'src/common/components/CustomButton';
import UtilInputs from 'src/common/components/UtilInputs';
import CalendarModal from './Calendar/CalendarModal';
import NotifyChanges from './NotifyChanges/NotifyChanges';
import AttendanceModal from './Attendance/AttendanceModal';
import { Grid } from '@material-ui/core';
import { organsAPI } from 'src/api/modules/organs';
import { useSelector } from 'react-redux';
import { getAllOrgans } from 'src/utils/getSubOrganos';
import { downloadZip } from 'src/pages/Files/UpaloadFileMinos';
import { sessionsAPI } from 'src/api/modules/sessions';
import { useParams, useHistory } from 'react-router-dom';
import { DateRange, Folder, Edit } from '@material-ui/icons';
import {
	btnsCreate,
	labelsNewSession,
	defaultNewSession,
	labelsOrganSelected,
	btnsPublishedStatus,
} from './utils/list_data';
import { ZipComponent } from './ZipComponent';

const FormSession = ({ isNew }) => {
	const { id } = useParams();
	const history = useHistory();
	const [hide, setHide] = useState(false);
	const [organs, setOrgans] = useState([]);
	const filial = localStorage.getItem('type');
	const [btnEdit, setBtnEdit] = useState(false);
	const { user } = useSelector((state) => state.auth);
	const [elecFolder, setElecFolder] = useState(false);
	const [attendance, setAttendance] = useState(false);
	const [disableForm, setDisableForm] = useState(false);
	const [session, setSession] = useState(defaultNewSession);
	const [seeAttendance, setSeeAttendance] = useState(false);
	const [calendarModal, setCalendarModal] = useState(false);
	const [notifyChanges, setNotifyChanges] = useState(false);
	const systemLevelRole = user?.organos[0].nombrePerfil.toUpperCase();
	const reduxOrgan = useSelector((state) => state.organsByRol.organs);
	const hideActions = ['ENLACE', 'CONSULTA', 'RESPONSABLE DE SEGUIMIENTO'];
	const showEverything = ['ADMINISTRADOR GENERAL', 'SISTEMA', 'RESPONSABLE DE NEGOCIO'];
	const usersCanEdit = [
		'ADMINISTRADOR GENERAL',
		'RESPONSABLE DE ORGANO COLEGIADO',
		'SISTEMA',
		'RESPONSABLE DE NEGOCIO',
	];

	useEffect(() => {
		getOrgans();

		if (isNew) setBtnEdit(false);
		else {
			setBtnEdit(usersCanEdit.includes(systemLevelRole));
			setHide(hideActions.includes(systemLevelRole));
			setDisableForm(true);
		}

		if (id) {
			sessionsAPI
				.getBySession(id)
				.then((response) => {
					const fecha = response.fecha.split('-');

					response.fhora = new Date(
						fecha[2] + '-' + fecha[1] + '-' + fecha[0] + 'T' + response.hora
					);
					response.nameOrgan =
						response.organoColegiado.nombre !== undefined
							? response.organoColegiado.nombre
							: '';

					setSession(response);
					validateAttendance(response.publicada);
				})
				.catch((e) => notice('Ocurrio un error'));
		} else setSession(defaultNewSession);
	}, [id]);

	const validateAttendance = (sessionPublicada) => {
		if (sessionPublicada === 'P' && usersCanEdit.includes(systemLevelRole))
			setSeeAttendance(true);
	};

	const crearActualizarSesion = () => {
		const sesionForm = Object.assign({}, session);
		if (sesionForm.lugar === '') return notice('El campo lugar es requerido');
		let dateHour = session.fhora;
		let bodyData = sesionForm;
		delete bodyData.nameOrgan;
		if (sesionForm.fhora !== undefined) {
			let fecha = moment(sesionForm.fhora).format('L').toString();
			let date = fecha.replaceAll('/', '-');
			let hora = new Date(sesionForm.fhora).toLocaleTimeString('en-GB').split(':');
			bodyData.fecha = date;
			bodyData.hora = hora[0] + ':' + hora[1];
			delete bodyData.fhora;
		}

		bodyData.id = id == null ? 0 : id;
		bodyData.usuarioId = user.id;

		if (sesionForm.id === 0)
			sessionsAPI
				.postSesion(bodyData)
				.then((response) => {
					if (
						response.codigo === 'SAOC-400' ||
						response.codigo === 'SAOC: 500'
					) {
						notice(JSON.parse(JSON.stringify(response.mensaje)));
					} else {
						notice('Sesión creada con éxito', 'success');
						history.push(
							`/sesiones/consultar-sesiones/sesion/${response.id}`
						);
					}
				})
				.catch((e) => {
					if (e.response.data.mensaje === undefined)
						notice('Ha ocurrido un error con su petición');
					else notice(JSON.parse(JSON.stringify(e.response.data.mensaje)));

					setSession({ ...session, fhora: dateHour });
					return false;
				});
		else
			sessionsAPI
				.putSesion(bodyData)
				.then((response) => {
					if (response.codigo === 'SAOC-400' || response.codigo === 'SAOC: 500')
						notice(JSON.parse(JSON.stringify(response.mensaje)));
					else {
						onEdit();
						response.publicada === 'P'
							? setNotifyChanges(true)
							: notice('Actualizado con Éxito', 'success');
					}
				})
				.catch((e) => {
					notice(e?.message, 'error');
				});
	};
	const [descargados, setDescargados] = useState(0);
	const [totales, setTotales] = useState(0);
	const porcentaje = totales > 0 ? Math.round((descargados / totales) * 100) : 0;
	const [isDownloading, setIsDownloading] = useState(false);

	const downloadElectronicFolder = () => {
		setElecFolder(true);

		sessionsAPI
			.getFilesFolder(id)
			.then((response) => {
				if (response.length === 0) {
					setElecFolder(false);
					notice(
						'No hay archivos cargados dentro de la orden del día',
						'warning'
					);
					return; // Para evitar que intente hacer downloadZip si no hay archivos
				}
				setIsDownloading(true);
				let name = session.numero_sesion;
				setTotales(response.length);
				downloadZip(
					response,
					user,
					setElecFolder,
					name,
					session.migrado,
					setDescargados,
					setIsDownloading,
					descargados,
					setTotales
				);
			})
			.catch((err) => {
				notice('No se pudo descargar la carpeta electronica');
				setElecFolder(false);
			});
	};

	const getOrgans = () => {
		if (showEverything.includes(systemLevelRole) === true && filial === null) {
			organsAPI
				.get('get')
				.then((response) => {
					if (response && response.length > 0) {
						setOrgans(getAllOrgans(response));
					}
				})
				.catch((e) => notice('Ocurrio un error al cargar órganos colegiados'));
		} else {
			setOrgans(reduxOrgan);
		}
	};

	const handleChange = (e) => {
		let { name, value } = e.target;
		setSession({ ...session, [name]: value });
	};

	const onConfirmDate = (dateSession) => {
		setSession({ ...session, fhora: dateSession });
	};

	const openCalendarModal = () => {
		setCalendarModal(true);
	};

	const onEdit = () => {
		setBtnEdit(!btnEdit);
		setDisableForm(!disableForm);
	};

	return (
		<>
			<Grid container spacing={1}>
				<Grid item xs={12} md={4} lg={4}>
					<h2>{isNew ? 'Crear Nueva Sesión' : session.numero_sesion}</h2>
					<div className="mt-lg-6">
						<UtilInputs
							onValuesChange={handleChange}
							formValues={session}
							inputValues={labelsOrganSelected(organs, disableForm)}
						/>
						<div className="col-sm-12 mt-4">
							<CustomButton
								key={'btnCalendar'}
								mainText={'Calendario de sesiones'}
								onClick={() => {
									openCalendarModal();
								}}
								className={'mt-4 btn-block'}
								disabled={session?.organoId ? false : true}
								icon={DateRange}
							/>
							{!isDownloading && (
								<CustomButton
									mainText={'Carpeta Electrónica'}
									onClick={() => {
										downloadElectronicFolder();
									}}
									className={isNew ? 'd-none' : 'mt-4 btn-block'}
									disabled={elecFolder}
									icon={Folder}
									loading={elecFolder}
								/>
							)}

							{isDownloading && (
								<ZipComponent
									descargados={descargados}
									totales={totales}
									porcentaje={porcentaje}
								/>
							)}
						</div>

						{seeAttendance &&
							btnsPublishedStatus(
								() => setAttendance(true),
								() => setNotifyChanges(true)
							).map((button) => (
								<CustomButton
									key={'btn' + button.title}
									mainText={button.title}
									onClick={button.onClick}
									disabled={button.disabled}
									className={button.className}
								/>
							))}
					</div>
				</Grid>
				<Grid item md={8} lg={8} height={'100%'}>
					<div className="border rounded">
						<div className="mt-lg-2 m-2 ">
							{btnEdit && (
								<CustomButton
									key={'btnEdit'}
									className={'float-right'}
									icon={Edit}
									onClick={() => {
										onEdit();
									}}
								/>
							)}
						</div>
						<div className="m-5">
							<h4>Datos de sesión</h4>
							<UtilInputs
								onValuesChange={handleChange}
								formValues={session}
								inputValues={labelsNewSession(disableForm)}
							/>
						</div>
					</div>
					{btnEdit === false &&
						btnsCreate(crearActualizarSesion, id, onEdit, hide).map(
							(button) => (
								<CustomButton
									key={'btn' + button.title}
									mainText={button.title}
									color={button.color}
									onClick={button.onClick}
									disabled={button.disabled}
									className={button.className}
								/>
							)
						)}
				</Grid>
			</Grid>
			<CalendarModal
				open={calendarModal}
				setOpen={setCalendarModal}
				idSession={id}
				onConfirmDate={onConfirmDate}
				organoID={session?.organoId}
			/>
			<AttendanceModal
				open={attendance}
				boton={setAttendance}
				setOpen={setAttendance}
				idSession={id}
			/>
			<NotifyChanges
				open={notifyChanges}
				setOpen={setNotifyChanges}
				idSession={id}
				organID={session?.organoId}
				dataSession={session}
			/>
		</>
	);
};

export default FormSession;
